export { default as SendPasswordResetForm } from './component';
